import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LineItemType, Money } from '../../type/order';
import { LineItem } from './LineItem';
/**
 * A request for court audio
 */
export class AudioLineItem extends LineItem {
    constructor() {
        super(...arguments);
        this.type = LineItemType.Audio;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Identifies whether this order should retrieve speech to text for the audio segment id
     */
    )
], AudioLineItem.prototype, "estimate", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], AudioLineItem.prototype, "speechToTextFee", void 0);
